import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
 
  {
    path: '/myComment',//我的评论
    name: 'MyComment',
    component: () => import( '../views/villages/MyComment.vue')
  },
  {
    path: '/myPost',//我的帖子
    name: 'MyPost',
    component: () => import( '../views/villages/MyPost.vue')
  },
  {
    path: '/heavyCurrency',//我的重消币
    name: 'HeavyCurrency',
    component: () => import( '../views/heavycurrency/HeavyCurrency.vue')
  },
  {
    path: '/investCurrency',//充值重消币
    name: 'InvestCurrency',
    component: () => import( '../views/heavycurrency/InvestCurrency.vue')
  },
  {
    path: '/payRecords',//消费记录
    name: 'PayRecords',
    component: () => import( '../views/heavycurrency/PayRecords.vue')
  },
  {
    path: '/myQrcode',//我的二维码
    name: 'MyQrcode',
    component: () => import( '../views/heavycurrency/MyQrcode.vue')
  },
  {
    path: '/myDealer',//我的经销商
    name: 'MyDealer',
    component: () => import( '../views/heavycurrency/MyDealer.vue')
  },
  {
    path: '/dealerDetails',//我的经销商详情
    name: 'DealerDetails',
    component: () => import( '../views/heavycurrency/DealerDetails.vue')
  },
  {
    path: '/editPassword',//修改密码
    name: 'EditPassword',
    component: () => import( '../views/heavycurrency/EditPassword.vue')
  },
  {
    path: '/villages',
    name: '村村通',
    component: () => import('../views/villages/index.vue'),
    redirect: "/areaTrends",
    children:[
      {
        path: '/areaTrends',
        name: 'AreaTrends',
        component: () => import('../views/villages/AreaTrends.vue'),
      },
      {
        path: '/postDetails',
        name: 'PostDetails',
        component: () => import('../views/villages/PostDetails.vue'),
      },
      {
        path: '/dynamicDetails',
        name: 'DynamicDetails',
        component: () => import('../views/villages/DynamicDetails.vue'),
      },
      {
        path: '/pushAtrends',
        name: 'PushAtrends',
        component: () => import('../views/villages/PushAtrends.vue'),
      }
    ]
  },
  {
    path: '/bind',
    name: 'bind',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/bind.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/loginOld',
    name: 'loginOld',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/loginOld.vue')
  },
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/index/index.vue')
  },

  {
    path: '/businessList',
    name: 'businessList',
    component: () => import('../views/merchantGoodsList/businessList.vue')
  },
  {
    path: '/goodsList',
    name: 'goodsList',
    component: () => import('../views/merchantGoodsList/goodsList.vue')
  },
  {
    path: '/dayLotteryList',
    name: 'dayLotteryList',
    component: () => import('../views/merchantGoodsList/dayLotteryList.vue')
  },
  {
    path: '/goodsKind',
    name: 'goodsKind',
    component: () => import('../views/goodsKind/goodsKind.vue')
  },
  {
    path: '/kindDetail',
    name: 'kindDetail',
    component: () => import('../views/goodsKind/kindDetail.vue')
  },
  {
    path: '/goodsDetail',
    name: 'goodsDetail',
    component: () => import('../views/goodsDetail/goodsDetail.vue')
  },
  {
    path: '/commentDetail',
    name: 'commentDetail',
    component: () => import('../views/goodsDetail/commentDetail.vue')
  },
  {
    path: '/shopIndex',
    name: 'shopIndex',
    component: () => import('../views/shopIndex/shopIndex.vue')
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () => import('../views/shopIndex/customerService.vue')
  },
  {
    path: '/LuckDraw',
    name: 'LuckDraw',
    component: () => import('../views/LuckDraw/LuckDraw.vue')
  },
  {
    path: '/luckDrawAddress',
    name: 'luckDrawAddress',
    component: () => import('../views/addAdress/luckDrawAddress.vue')
  },
  {
    path: '/addAdress',
    name: 'addAdress',
    component: () => import('../views/addAdress/addAdress.vue')
  },
  {
    path: '/addAdresInfo',
    name: 'addAdresInfo',
    component: () => import('../views/addAdress/addAdresInfo.vue')
  },
  {
    path: '/chooseAdress',
    name: 'chooseAdress',
    component: () => import('../views/addAdress/chooseAdress.vue')
  },
  {
    path: '/noticeList',
    name: 'noticeList',
    component: () => import('../views/notice/noticeList.vue')
  },
  {
    path: '/noticeDetail',
    name: 'noticeDetail',
    component: () => import('../views/notice/noticeDetail.vue')
  },
  {
    path: '/SuccessfulPayment',
    name: 'SuccessfulPayment',
    component: () => import('../views/SuccessfulPayment/SuccessfulPayment.vue')
  },
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: () => import('../views/shoppingCart/shoppingCart.vue')
  },
  {
    path: '/ConfirmationOrder',
    name: 'ConfirmationOrder',
    component: () => import('../views/shoppingCart/ConfirmationOrder.vue')
  },
  {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import('../views/shoppingCart/orderPay.vue')
  },
  {
    path: '/personalData',
    name: 'personalData',
    component: () => import('../views/myHome/personalData.vue')
  },
  //收藏的商品与店铺
  {
    path: '/collectionGoods',
    name: 'collectionGoods',
    component: () => import('../views/myHome/collectionGoods.vue')
  },
  //足迹
  {
    path: '/myTracks',
    name: 'myTracks',
    component: () => import('../views/myHome/myTracks.vue')
  },
  //订单
  {
    path: '/myOrders',
    name: 'myOrders',
    component: () => import('../views/myHome/myOrders.vue')
  },
  {   
    path: '/invoice',
    name: 'invoice',
    component: () => import('../views/myHome/invoice.vue')
  },
  {   
    path: '/intelligence',
    name: 'intelligence',
    component: () => import('../views/myHome/intelligence.vue')
  },
  {   
    path: '/intelligenceInfo',
    name: 'intelligenceInfo',
    component: () => import('../views/myHome/intelligenceInfo.vue')
  },
  {   
    path: '/retreat',
    name: 'retreat',
    component: () => import('../views/myHome/retreat.vue')
  },
  {   
    path: '/logisticsInfo',
    name: 'logisticsInfo',
    component: () => import('../views/myHome/logisticsInfo.vue')
  },
  {   
    path: '/retreatInfo',
    name: 'retreatInfo',
    component: () => import('../views/myHome/retreatInfo.vue')
  },
  {   
    path: '/evaluateOrservice',
    name: 'evaluateOrservice',
    component: () => import('../views/myHome/evaluateOrservice.vue')
  },
  {   
    path: '/pendingPaymentInfo',
    name: 'pendingPaymentInfo',
    component: () => import('../views/myHome/pendingPaymentInfo.vue')
  },
  {   
    path: '/myIndex',
    name: 'myIndex',
    component: () => import('../views/myHome/index.vue'),
  },
  {   
    path: '/pendingDetails',
    name: 'pendingDetails',
    component: () => import('../views/myHome/pendingDetails.vue')
  },
  {   
    path: '/search',
    name: 'search',
    component: () => import('../views/index/search.vue')
  },
  {   
    path: '/searchResult',
    name: 'searchResult',
    component: () => import('../views/index/searchResult.vue')
  },
  {   
    path: '/test',
    name: 'test',
    component: () => import('../views/test.vue')
  }
]

const router = new VueRouter({
  routes 
})

export default router
